<script setup>
import VueEasyLightbox, { useEasyLightbox } from 'vue-easy-lightbox'

const props = defineProps(['src', 'alt'])

const {
    // methods
    show, onHide, changeIndex,
    // refs
    visibleRef, indexRef, imgsRef
} = useEasyLightbox({
    // src / src[]
    imgs: props.src,
    // initial index
    initIndex: 0
})

const handleShow = (index) => {
    changeIndex(index)
    show()
}
</script>

<template>
    <vue-easy-lightbox
        :visible="visibleRef"
        :imgs="imgsRef"
        :index="indexRef"
        @hide="onHide"
    />
    <picture>
        <img :src="src" 
             :alt="alt" 
             loading="lazy"
            @click="handleShow(0)"
        />
    </picture>
</template>